import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { msalInitPromise } from "./auth/msalConfig";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    "Root element #root not found in the document. Check index.html."
  );
}

// Only wait for MSAL init — let MsalProvider handle the redirect internally
msalInitPromise.then(() => {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
